module.exports = __webpack_public_path__ + "static/media/twitter.05937f18.png";